<div style="overflow: hidden; position: relative" id="cpin-element">
  <div>
    <div class="cpinHeader" style="padding: 20px 5px 20px 10px; text-align: center; font-size: 25px">
      <h5 style="margin: 0">{{ rGuestBookMessages.profile.profilePinValidationCasinoNumberText }}{{ casinoNumber }}</h5>
    </div>
    <div class="cpinError" style="font-size: 15px; padding: 20px; font-weight: 600" *ngIf="message">
      {{ message }}
    </div>
    <div id="casinoPinValidation">
      <div id="cpinFrame" class="card" style="display: block">
        <div class="card-body" style="height: 220px">
          <form novalidate #cpinform="ngForm" *ngIf="!preload">
            <mat-form-field class="cpin-mat-field">
              <mat-label class="is-focused">{{ rGuestBookMessages.profile.profileIframePinNumberPlaceholderText }}</mat-label>
              <input [(ngModel)]="cPin" name="cardNumber" #cardNumber="ngModel" matInput type="password" autocomplete="off" />
            </mat-form-field>
            <p style="margin-top: 3px; color: #f44336; max-width: 260px" id="error">{{ errorMessage }}</p>
            <div style="text-align: center; margin-top: 30px">
              <button
                class="btn btn-raised btn-primary custom-button"
                style="margin-right: 5px"
                id="btnSubmit"
                (click)="validatePin()"
                type="submit">
                {{ rGuestBookMessages.profile.profileIframeButtonSubmitText }}
              </button>
              <button class="btn btn-raised btn-warning custom-button" id="btnclose" (click)="closeBtn()" type="button">
                {{ rGuestBookMessages.profile.profileIframeButtonCancelText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="preload"
    class="cpinPreloaderBackgroundColor"
    style="position: absolute; width: 100%; top: 0; height: 100%; overflow: hidden"></div>
  <div *ngIf="preload">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
      <h5 class="cpinPreloaderColor" style="width: 100px; margin-left: -25px">
        {{ rGuestBookMessages.offer.offerMessage7 }}
      </h5>
    </div>
  </div>
</div>
